// AccountingStore.tsx
import { create } from "zustand";

import { ButtonSwitcherValue } from "../components/Utils/ButtonSwitcher/ButtonSwitcher";
import AccountingExpenseType from "../types/AccountingExpense";
import AccountingRevenueType from "../types/AccountingRevenue";
import useUserStore from "./UserStore";

export const getDefaultAccountingTvaRate = () =>
  useUserStore.getState().isVatSubject ? 21 : 0;

export const createInitialExpense = (): AccountingExpenseType => ({
  expense_id: -1,
  user_id: -1,
  product_name: "",
  price: 0,
  tva_rate: getDefaultAccountingTvaRate(),
  recorded_date: new Date(),
  payment_method: "",
  file_path: "",
  file: null,
  files: [],
  user: { name: "Organization", user_id: -1, email: "" },
});

export const createInitialRevenue = (): AccountingRevenueType => ({
  revenue_id: -1,
  product_name: "",
  unit_price: 0,
  amount: 0,
  tva_rate: getDefaultAccountingTvaRate(),
  recorded_date: new Date(),
  payment_method: "",
  file_path: "",
  file: null,
  files: [],
});

interface AccountingState {
  accountingType: ButtonSwitcherValue;
  setAccountingType: (accountingType: ButtonSwitcherValue) => void;
  expense: AccountingExpenseType;
  setExpense: (
    expense:
      | AccountingExpenseType
      | ((prevExpense: AccountingExpenseType) => AccountingExpenseType),
  ) => void;

  revenue: AccountingRevenueType;
  setRevenue: (
    revenue:
      | AccountingRevenueType
      | ((prevRevenue: AccountingRevenueType) => AccountingRevenueType),
  ) => void;
}

const useAccountingStore = create<AccountingState>((set) => ({
  accountingType: { id: "sortie", name: "Sortie" },
  setAccountingType: (accountingType) => set(() => ({ accountingType })),
  // État initial de l'expense
  expense: createInitialExpense(),
  setExpense: (expense) =>
    set((state) => ({
      expense: typeof expense === "function" ? expense(state.expense) : expense,
    })),

  // État initial du revenue
  revenue: createInitialRevenue(),
  setRevenue: (revenue) =>
    set((state) => ({
      revenue: typeof revenue === "function" ? revenue(state.revenue) : revenue,
    })),
}));

export default useAccountingStore;
